export default "__VITE_ASSET__999d5c56__"